import Image from "next/image";
import { useState } from "react";
import Container from "../common/Container";
import Modal from "../common/Modal";

const HireTeamCard = (properties) => {
  const { devWehave, totalDev, devTechName, countColor, image } =
    properties.mainCTASection;
    
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Container large className=" mt-24 mb-20 md:mb-0">
        <div className="flex flex-col md:flex-row">
          <div className="bg-primary-black md:w-7/12 flex flex-col md:flex-row justify-center items-center rounded-tr-2xl md:rounded-tr-none rounded-bl-none rounded-tl-2xl md:rounded-bl-2xl md:gap-10">
            <div>
              <span
                className="font-medium text-[226px] leading-[284px] md:text-[120px] md:leading-[151px] lg:text-[226px] lg:leading-[284px] bg-clip-text text-transparent"
                style={{ backgroundImage: countColor }}
              >
                {devWehave}
              </span>
              <span
                className="bg-clip-text text-transparent font-bold text-3xl lg:text-2xl -ml-2"
                style={{ backgroundImage: countColor }}
              >
                /{totalDev}
              </span>
            </div>
            <div className="lg:pt-8">
              <p className="text-3xl md:text-base lg:text-2xl text-white m-0">
                <span>{devTechName}</span>
              </p>
              <p className="text-3xl md:text-base lg:text-2xl text-white m-0">
                <span>are Available for</span>
              </p>
              <p className="text-white font-bold text-8xl md:text-5xl lg:text-8xl pb-16 md:pb-0 mb-0">
                <span>Hiring</span>
              </p>
            </div>
          </div>
          <div
            className="relative md:w-5/12 py-16 px-12 md:pt-10 md:pr-0 md:pb-10 md:pl-10 lg:pt-14 lg:pb-12 lg:pl-12 lg:pr-0 rounded-tr-none rounded-bl-2xl rounded-br-2xl md:rounded-tr-2xl md:rounded-br-2xl md:rounded-bl-none"
            style={{ background: countColor }}
          >
            <div className="flex pb-8">
              <div className="md:w-10 md:h-10 lg:w-fit lg:h-fit">
                <Image
                  alt="developer"
                  height={46}
                  quality={100}
                  src="/assets/technologies/developer-1.webp"
                  width={46}
                />
              </div>
              <div className="-ml-4 md:w-10 md:h-10 lg:w-fit lg:h-fit">
                <Image
                  alt="developer"
                  height={46}
                  quality={100}
                  src="/assets/technologies/developer-2.webp"
                  width={46}
                />
              </div>
              <div className="-ml-4 md:w-10 md:h-10 lg:w-fit lg:h-fit">
                <Image
                  alt="developer"
                  height={46}
                  quality={100}
                  src="/assets/technologies/developer-3.webp"
                  width={46}
                />
              </div>
            </div>
            <p className="text-xl text-white md:mb-0 lg:mb-4">
              <span>Let’s Get Started in</span>
            </p>
            <p className="text-3xl md:text-xl lg:text-4xl font-bold text-white mb-10 md:mb-4 lg:mb-8 leading-relaxed">
              <span>1 Business Day!</span>
            </p>
            <div className="flex justify-between align-center">
              <button
                className="border-0 text-base md:text-sm lg:text-lg py-3 px-6 lg:py-4 lg:px-10 w-full md:w-fit bg-white font-semibold rounded-lg"
                onClick={openModal}
              >
                <span>Book a 30 min Call Now</span>
              </button>
            </div>
            <div className="absolute top-0 right-0 w-2/6 md:w-1/6 lg:w-2/6">
              <Image
                alt="kotlin"
                height={237}
                quality={100}
                src={image}
                width={237}
              />
            </div>
          </div>
        </div>
      </Container>
      <Modal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
};

export default HireTeamCard;
